import { Component, Input, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { take } from 'rxjs/operators';

import { ApiError, MessageService } from '../../../core';
import { ClienteAnaliseMercado } from '../cliente-analise-mercado';
import { ClienteAnaliseMercadoHttpService, ClienteAnaliseMercadoRouterService } from '../services';
import { ClienteAnaliseMercadoClassificacaoLancamentoComponent, ClienteAnaliseMercadoClassificacaoSearchLancamento } from '../classificacao/lancamento';
import { ClienteAnaliseMercadoLancamento, ClienteAnaliseMercadoLancamentoFormModalComponent } from '../lancamento';
import { ClienteAnaliseMercadoPerspectiva } from '../perspectivas/cliente-analise-mercado-perspectiva';

@Component({
    selector: 'sgt-cliente-analise-mercado-form',
    templateUrl : './cliente-analise-mercado-form.component.html',
    styleUrls: ['./cliente-analise-mercado-form.component.less']
})
export class ClienteAnaliseMercadoFormComponent implements OnInit, OnDestroy {
    entity: ClienteAnaliseMercado;
    perspectiva: ClienteAnaliseMercadoPerspectiva;

    @ViewChild('clienteAnaliseMercadoClassificacaoLancamento') clienteAnaliseMercadoClassificacaoLancamento: ClienteAnaliseMercadoClassificacaoLancamentoComponent;
    @ViewChild('lancamentoFormModal') lancamentoFormModal: ClienteAnaliseMercadoLancamentoFormModalComponent;

    constructor(private activatedRoute: ActivatedRoute,
                private router: Router,
                private messageService: MessageService,
                private clienteAnaliseMercadoRouterService: ClienteAnaliseMercadoRouterService,
                private clienteAnaliseMercadoHttpService: ClienteAnaliseMercadoHttpService) { }

    ngOnInit() {
        // this.activatedRoute.params.subscribe((params: Params) => {
        //     // ID Cliente
        //     this.idCliente = +params['idCliente'];
        //     // Ano
        //     this.ano = +params['ano'];

        //     // Análise de Mercado
        //     this.load(this.idCliente, this.ano)
        //         .then(() => {
        //             // Classificações
        //             this.clienteAnaliseMercadoClassificacaoLancamento?.search()
        //                 .then(() => {})
        //                 .catch(() => {});
        //         })
        //         .catch(() => {});
        // });
    }

    async load(idCliente: number, ano: number, perspectiva: ClienteAnaliseMercadoPerspectiva): Promise<void> {
        try {
            this.perspectiva = perspectiva;

            // Carregando a análise de mercados do cliente no ano
            await this.loadAnaliseMercado(idCliente, ano);
            // Carregando as análises de mercados das classificações do cliente no ano
            await this.clienteAnaliseMercadoClassificacaoLancamento?.search();
        } catch (error) {
            console.error(error);
        }
    }

    private loadAnaliseMercado(idCliente: number, ano: number): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            // this.entity = null;
            this.clienteAnaliseMercadoHttpService.load(idCliente, ano)
                .pipe(
                    take(1)
                )
                .subscribe(
                    entity => {
                        this.entity = entity;
                        setTimeout(() => resolve(), 0);
                    },
                    (error: ApiError) => {
                        this.messageService.error(error.message, 'Erro ao carregar a análise de mercado do cliente', error);
                        reject();
                    }
                );
        });
    }

    /** Após criar um novo lançamento de classificação na análise de mercado */
    afterCreateLancamentoClassificacao(lancamento: ClienteAnaliseMercadoLancamento) {
        if (lancamento) { // Abrindo o lançamento criado
            this.lancamentoFormModal?.open(this.perspectiva, this.entity.idCliente, this.entity.ano, lancamento.idClienteAnaliseMercadoClassificacao,  null, null, false, true);
        } else { // Recarregando a análise de mercado do cliente
            this.load(this.entity.idCliente, this.entity.ano, this.perspectiva)
                .then(() => {})
                .catch(() => {});
        }

    }

    /** Após excluir um lançamento de classificação da análise de mercado */
    afterDeleteLancamentoClassificacao() {
        // Recarregando a análise de mercado do cliente
        this.load(this.entity.idCliente, this.entity.ano, this.perspectiva)
            .then(() => {})
            .catch(() => {});
    }

    /** Abre o lançamento da análise de mercado da classificação */
    openLancamentoClassificacao(classificacao: ClienteAnaliseMercadoClassificacaoSearchLancamento) {
        this.lancamentoFormModal?.open(this.perspectiva, this.entity.idCliente, this.entity.ano, classificacao?.id, null, null, false, true);
    }

    /** Após salvar o lançamento da análise de mercado da classificação */
    afterSaveLancamentoClassificacao() {
        // Recarregando a análise de mercado do cliente
        this.load(this.entity.idCliente, this.entity.ano, this.perspectiva)
            .then(() => {})
            .catch(() => {});
    }

    goBack() {
        this.clienteAnaliseMercadoRouterService.goToRoot(this.activatedRoute);
    }

    ngOnDestroy() {

    }
}

